export default {
  id: 210,
  title: 'Target #210 - Black widow logo',
  url: 'https://cssbattle.dev/play/210',
  colors: ['#151917', '#D83A34'],
  solution:
    '<style>body{background:radial-gradient(circle,transparent 105px,#d83a34 105px 125px,#151917 125px),conic-gradient(at 216px 150px,transparent 34deg,#151917 34deg 146deg,transparent 146deg),conic-gradient(from 180deg at 183px 150px,transparent 34deg,#151917 34deg 146deg,transparent 146deg),linear-gradient(#151917 81px,#d83a34 81px 219px,#151917 219px)',
}
